document.addEventListener("DOMContentLoaded", () => {
  const popup = document.querySelector("#callback-popup");
  const openBtn = document.querySelector(".callback-button");
  const closeBtn = document.querySelector(".callback-popup__close");
  const overlay = document.querySelector(".callback-popup__overlay");
  const form = document.querySelector("#callback-form");
  const success = document.querySelector(".callback-success");

  if (!popup || !openBtn) return;

  // ---------- SUCCESS AFTER REDIRECT ----------
  if (new URLSearchParams(window.location.search).get("contact[posted_successfully]") === "1") {
    popup.style.display = ""; // remove inline style
    popup.classList.add("open");
    if (form) form.style.display = "none";
    if (success) success.style.display = "block";
  }

  // ---------- OPEN ----------
  openBtn.addEventListener("click", () => {
    popup.style.display = ""; // remove inline style
    popup.classList.add("open");
    if (form) form.style.display = "block";
    if (success) success.style.display = "none";
    form?.reset();
  });

  // ---------- CLOSE ----------
  const close = () => popup.classList.remove("open");

  closeBtn?.addEventListener("click", close);
  overlay?.addEventListener("click", close);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && popup.classList.contains("open")) {
      close();
    }
  });
});
